import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    referenceUserId: string;
    userId: string;
};

export const schemaUserResolver_IsInCorporation = z.boolean();

export type SchemaUserResolver_IsInCorporation = z.infer<typeof schemaUserResolver_IsInCorporation>;

export type UserResolver_IsInCorporation = Resolver<Arguments, SchemaUserResolver_IsInCorporation>;
